/* eslint-disable camelcase */
import {
  ELIGIBILITY_STATUS,
  EPL_LOCAL_DATA,
  EPL_NOT_ELIGIBLE_MODAL_FOR_ALL_SHOW,
  EPL_NOT_ELIGIBLE_MODAL_FOR_SOME_SHOW,
} from "data/constants"
import { DataStore } from "shared/helpers/localStorage"

const {
  EPL_LOCAL_STORAGE,
  SHOW_MODAL_ALL_BLOCKED,
  SHOW_MODAL_SOME_BLOCKED,
  DONT_SHOW,
  ALL,
  SOME,
  ELIGIBILITY_CHECK,
} = EPL_LOCAL_DATA

export const getActiveAccount = ({ activeAccount, accounts = [] }) =>
  accounts.find(account => account.account_id === activeAccount)

export const isUserEligibleForEbayMarketing = account => {
  const plaEligibility = account.pla_eligibility_status
  const plsEligibility = account.pls_eligibility_status

  if (
    plaEligibility === ELIGIBILITY_STATUS.NOT_PROCESSED &&
    plsEligibility === ELIGIBILITY_STATUS.NOT_PROCESSED
  )
    return ELIGIBILITY_STATUS.NOT_PROCESSED
  if (
    plaEligibility === ELIGIBILITY_STATUS.ELIGIBLE ||
    plsEligibility === ELIGIBILITY_STATUS.ELIGIBLE
  )
    return ELIGIBILITY_STATUS.ELIGIBLE

  return ELIGIBILITY_STATUS.NOT_ELIGIBLE
}

const setShowNotEligibleModal = ({ type, modal }) => {
  const userStoredData = DataStore.getAll(EPL_LOCAL_STORAGE)
  if (userStoredData !== null) {
    const typeValue =
      userStoredData?.[ELIGIBILITY_CHECK]?.[type] !== DONT_SHOW
        ? modal
        : DONT_SHOW
    DataStore.set(EPL_LOCAL_STORAGE, {
      [ELIGIBILITY_CHECK]: {
        ...userStoredData?.[ELIGIBILITY_CHECK],
        [type]: typeValue,
      },
    })
  } else {
    DataStore.set(EPL_LOCAL_STORAGE, { [ELIGIBILITY_CHECK]: { [type]: modal } })
  }
}

const showNotEligibleModal = action => {
  const { type } = action.data
  const modalStatus =
    DataStore.getAll(EPL_LOCAL_STORAGE)?.[ELIGIBILITY_CHECK]?.[type]
  if (modalStatus === DONT_SHOW) return false
  const modalType =
    type === ALL ? SHOW_MODAL_ALL_BLOCKED : SHOW_MODAL_SOME_BLOCKED

  const modalTypeAction =
    type === ALL
      ? EPL_NOT_ELIGIBLE_MODAL_FOR_ALL_SHOW
      : EPL_NOT_ELIGIBLE_MODAL_FOR_SOME_SHOW

  if (![SHOW_MODAL_ALL_BLOCKED, SHOW_MODAL_SOME_BLOCKED].includes(modalStatus))
    setShowNotEligibleModal({ type, modal: modalType })
  return modalTypeAction
}

const isNotEligibleForAll = (accounts, activeAccount) => {
  const currentAccount = getActiveAccount({
    activeAccount,
    accounts,
  })

  return (
    currentAccount?.pls_eligibility_status ===
      ELIGIBILITY_STATUS.NOT_ELIGIBLE &&
    currentAccount?.pla_eligibility_status === ELIGIBILITY_STATUS.NOT_ELIGIBLE
  )
}

const isNotEligibleForSome = markets =>
  markets.filter(el => el.is_eligible === false).length > 0

export const marketsEligibilityCheck = markets =>
  !isNotEligibleForSome(markets) &&
  showNotEligibleModal({
    type: EPL_NOT_ELIGIBLE_MODAL_FOR_SOME_SHOW,
    data: { type: SOME },
  })

export const accountEligibilityCheck = (accounts, activeAccount) =>
  isNotEligibleForAll(accounts, activeAccount) &&
  showNotEligibleModal({
    type: EPL_NOT_ELIGIBLE_MODAL_FOR_ALL_SHOW,
    data: { type: ALL },
  })

export const getMarketsEligibility = markets =>
  Object.values(
    markets.reduce((result, entry) => {
      const { site, funding_model, origin, is_eligible } = entry
      const updatedResult = {
        ...result,
        [site]: {
          ...result[site],
          site,
          eligibility: {
            ...result[site]?.eligibility,
            [funding_model]: {
              ...result[site]?.eligibility?.[funding_model],
              [origin]: is_eligible,
            },
          },
        },
      }

      return updatedResult
    }, {})
  )
